import requests from "./httpService";

const OnewayPickupPeriodicHikeTimeServices = {
  getAllOnewayPickupPeriodicHikeTime: async (body) => {
    return requests.get(`/onewaypickhiketime/`);
  },

  addOnewayPickupPeriodicHikeTime: async (body) => {
    return requests.post(`/onewaypickhiketime/add`, body);
  },
  getOnewayPickupPeriodicHikeTimeById: async (id) => {

    return requests.get(`/onewaypickhiketime/${id}`);
  },

  updateOnewayPickupPeriodicHikeTime: async (id, body) => {
    return requests.put(`/onewaypickhiketime/update/${id}`, body);
  },

  deleteOnewayPickupPeriodicHikeTime: async (id) => {
    return requests.delete(`/onewaypickhiketime/delete/${id}`);
  },
};

export default OnewayPickupPeriodicHikeTimeServices;
